import IMask from 'imask'

export const GeneralData = [
    [
        {
            name: 'name',
            label: 'Название',
            placeholder: 'Название',
            type: 'text',
            disabled: false,
            required: true,
        },
    ],
    [
        {
            name: 'price_per_hour',
            label: 'Цена, ₽/час',
            placeholder: '₽ 0',
            type: 'number',
            disabled: false,
            required: true,
            maskConfig: {
                scale: 2,
                mask: Number,
                radix: '.',
                mapToRadix: [','],
            },
        },
        {
            name: 'ad_price_info.more_than_three_hour_price_per_hour',
            label: 'Цена >3ч, ₽/час',
            placeholder: '₽ 0',
            type: 'number',
            disabled: false,
            maskConfig: {
                scale: 2,
                mask: Number,
                radix: '.',
                mapToRadix: [','],
            },
        },
        {
            name: 'ad_price_info.morning_price_per_hour',
            label: 'Утро, ₽/час',
            placeholder: '₽ 0',
            type: 'number',
            disabled: false,
            maskConfig: {
                scale: 2,
                mask: Number,
                radix: '.',
                mapToRadix: [','],
            },
        },
        {
            name: 'ad_price_info.evening_price_per_hour',
            label: 'Вечер, ₽/час',
            placeholder: '₽ 0',
            type: 'number',
            disabled: false,
            maskConfig: {
                scale: 2,
                mask: Number,
                radix: '.',
                mapToRadix: [','],
            },
        },
        {
            name: 'prepayment',
            label: 'Предоплата',
            placeholder: '0%',
            type: 'number',
            disabled: false,
            maskConfig: {
                mask: Number,
                min: 0,
                max: 100,
            },
        },
    ],
    [
        {
            name: 'ad_booking_info.minimum_booking_time_minutes',
            label: 'Минимальное время бронирования, час',
            placeholder: 'Выберите время',
            type: 'select',
            required: false,
        },
        {
            name: 'ad_price_info.morning_hours',
            label: 'Утренние часы',
            placeholder: '04:00 - 10:00',
            type: 'text',
            disabled: false,
            maskConfig: {
                mask: 'HH:MM - HH:MM',
                blocks: {
                    HH: {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 23,
                        maxLength: 2,
                    },
                    MM: {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 59,
                        maxLength: 2,
                    },
                },
            },
        },
        {
            name: 'ad_price_info.evening_hours',
            label: 'Вечерние часы',
            placeholder: '20:00 - 00:00',
            type: 'text',
            disabled: false,
            maskConfig: {
                mask: 'HH:MM - HH:MM',
                blocks: {
                    HH: {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 23,
                        maxLength: 2,
                    },
                    MM: {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 59,
                        maxLength: 2,
                    },
                },
            },
        },
        {
            name: 'ad_booking_info.unavailable_refund_period_days',
            label: 'Недоступный период для возврата средств',
            placeholder: '7 дней',
            type: 'text',
            disabled: false,
            maskConfig: { mask: Number },
        },
    ],
    [
        {
            name: 'ad_booking_info.available_online_booking_time',
            label: 'Доступное время для онлайн брони',
            placeholder: '10:00 - 13:00, 16:00 - 20:00',
            type: 'text',
            disabled: false,
            maskConfig: {
                mask: [
                    {
                        mask: 'HH:MM - HH:MM',
                        blocks: {
                            HH: {
                                mask: IMask.MaskedRange,
                                from: 0,
                                to: 23,
                                maxLength: 2,
                            },
                            MM: {
                                mask: IMask.MaskedRange,
                                from: 0,
                                to: 59,
                                maxLength: 2,
                            },
                        },
                    },
                    {
                        mask: 'HH:MM - HH:MM, HH:MM - HH:MM',
                        blocks: {
                            HH: {
                                mask: IMask.MaskedRange,
                                from: 0,
                                to: 23,
                                maxLength: 2,
                            },
                            MM: {
                                mask: IMask.MaskedRange,
                                from: 0,
                                to: 59,
                                maxLength: 2,
                            },
                        },
                    },
                    {
                        mask: 'HH:MM - HH:MM, HH:MM - HH:MM, HH:MM - HH:MM',
                        blocks: {
                            HH: {
                                mask: IMask.MaskedRange,
                                from: 0,
                                to: 23,
                                maxLength: 2,
                            },
                            MM: {
                                mask: IMask.MaskedRange,
                                from: 0,
                                to: 59,
                                maxLength: 2,
                            },
                        },
                    },
                ],
            },
        },
        {
            name: 'ad_booking_info.available_booking_time',
            label: 'Доступное время брони',
            placeholder: '22:00 - 03:00',
            type: 'text',
            disabled: false,
            maskConfig: {
                mask: 'HH:MM - HH:MM',
                blocks: {
                    HH: {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 23,
                        maxLength: 2,
                    },
                    MM: {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 59,
                        maxLength: 2,
                    },
                },
            },
        },
        {
            name: 'square',
            label: 'Площадь помещения',
            placeholder: '30м2',
            type: 'number',
            disabled: false,
            required: true,
            maskConfig: { mask: Number },
        },
    ],
    [
        {
            name: 'ad_booking_info.blocking_before_minutes',
            label: 'Блокировка бронирования ДО, мин',
            placeholder: '0',
            type: 'text',
            disabled: false,
            maskConfig: { mask: Number },
        },
        {
            name: 'ad_booking_info.blocking_after_minutes',
            label: 'Блокировка бронирования ПОСЛЕ, мин',
            placeholder: '0',
            type: 'text',
            disabled: false,
            maskConfig: { mask: Number },
        },
    ],
    [
        {
            name: 'equipment',
            label: 'Оборудование',
            placeholder: 'Выберите оборудование',
            type: 'equipment',
            required: false,
        },
    ],
]

export const TimeSlotSettings = [
    {
        name: 'ad_price_info.morning_hours',
        label: 'Утренние часы',
        placeholder: '04:00 - 10:00',
        type: 'text',
        disabled: false,
        maskConfig: {
            mask: 'HH:MM - HH:MM',
            blocks: {
                HH: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 23,
                    maxLength: 2,
                },
                MM: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59,
                    maxLength: 2,
                },
            },
        },
    },
    {
        name: 'ad_price_info.morning_price_per_hour',
        label: 'Утро, ₽/час',
        placeholder: '₽ 0',
        type: 'number',
        disabled: false,
        maskConfig: {
            scale: 2,
            mask: Number,
            radix: '.',
            mapToRadix: [','],
        },
    },
    {
        name: 'ad_price_info.evening_hours',
        label: 'Вечерние часы',
        placeholder: '20:00 - 00:00',
        type: 'text',
        disabled: false,
        maskConfig: {
            mask: 'HH:MM - HH:MM',
            blocks: {
                HH: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 23,
                    maxLength: 2,
                },
                MM: {
                    mask: IMask.MaskedRange,
                    from: 0,
                    to: 59,
                    maxLength: 2,
                },
            },
        },
    },
    {
        name: 'ad_price_info.evening_price_per_hour',
        label: 'Вечер, ₽/час',
        placeholder: '₽ 0',
        type: 'number',
        disabled: false,
        maskConfig: {
            scale: 2,
            mask: Number,
            radix: '.',
            mapToRadix: [','],
        },
    },
]

export const BookingSettings = [
    {
        name: 'ad_booking_info.available_online_booking_time',
        label: 'Доступное время для онлайн брони',
        placeholder: '10:00 - 13:00, 16:00 - 20:00',
        type: 'text',
        disabled: false,
        maskConfig: {
            mask: [
                {
                    mask: 'HH:MM - HH:MM',
                    blocks: {
                        HH: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 23,
                            maxLength: 2,
                        },
                        MM: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 59,
                            maxLength: 2,
                        },
                    },
                },
                {
                    mask: 'HH:MM - HH:MM, HH:MM - HH:MM',
                    blocks: {
                        HH: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 23,
                            maxLength: 2,
                        },
                        MM: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 59,
                            maxLength: 2,
                        },
                    },
                },
                {
                    mask: 'HH:MM - HH:MM, HH:MM - HH:MM, HH:MM - HH:MM',
                    blocks: {
                        HH: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 23,
                            maxLength: 2,
                        },
                        MM: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 59,
                            maxLength: 2,
                        },
                    },
                },
            ],
        },
    },
    {
        name: 'ad_booking_info.available_booking_time',
        label: 'Доступное время брони',
        placeholder: '10:00 - 13:00, 16:00 - 20:00',
        type: 'text',
        disabled: false,
        maskConfig: {
            mask: [
                {
                    mask: 'HH:MM - HH:MM',
                    blocks: {
                        HH: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 23,
                            maxLength: 2,
                        },
                        MM: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 59,
                            maxLength: 2,
                        },
                    },
                },
                {
                    mask: 'HH:MM - HH:MM, HH:MM - HH:MM',
                    blocks: {
                        HH: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 23,
                            maxLength: 2,
                        },
                        MM: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 59,
                            maxLength: 2,
                        },
                    },
                },
                {
                    mask: 'HH:MM - HH:MM, HH:MM - HH:MM, HH:MM - HH:MM',
                    blocks: {
                        HH: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 23,
                            maxLength: 2,
                        },
                        MM: {
                            mask: IMask.MaskedRange,
                            from: 0,
                            to: 59,
                            maxLength: 2,
                        },
                    },
                },
            ],
        },
    },
    {
        name: 'ad_booking_info.blocking_before_minutes',
        label: 'Блокировка бронирования ДО, мин',
        placeholder: '0',
        type: 'text',
        disabled: false,
        maskConfig: {
            mask: Number,
        },
    },
    {
        name: 'ad_booking_info.blocking_after_minutes',
        label: 'Блокировка бронирования ПОСЛЕ, мин',
        placeholder: '0',
        type: 'text',
        disabled: false,
        maskConfig: {
            mask: Number,
        },
    },
    {
        name: 'prepayment',
        label: 'Предоплата',
        placeholder: '0%',
        type: 'number',
        disabled: false,
        maskConfig: {
            mask: Number,
            min: 0,
            max: 100,
        },
    },
    {
        name: 'square',
        label: 'Площадь помещения',
        placeholder: '30м2',
        type: 'number',
        disabled: false,
        required: true,
        maskConfig: {
            mask: Number,
        },
    },
    {
        name: 'ad_booking_info.minimum_booking_time_minutes',
        label: 'Минимальное время бронирования, час',
        placeholder: 'Выберите время',
        type: 'select',
        required: false,
    },
    {
        name: 'ad_booking_info.unavailable_refund_period_days',
        label: 'Недоступный период для возврата средств',
        placeholder: '7 дней',
        type: 'text',
        disabled: false,
        maskConfig: {
            mask: Number,
        },
    },
]

export const EquipmentSettings = {
    name: 'equipment',
    label: 'Оборудование',
    placeholder: 'Выберите оборудование',
    type: 'equipment',
    required: false,
}

export const NameSettings = {
    name: 'name',
    label: 'Название',
    placeholder: 'Название',
    type: 'text',
    disabled: false,
    required: true,
}
